import EcoCalculatorRoute from "./EcoCalculatorRoute"
import Methodology from "./MethodologyRoute"

const routes = [
    new EcoCalculatorRoute(),
    new Methodology()
]

export default routes